require('../../scss/pages/subpages/dalsi-sluzby.scss');

$(document).ready(() => {
  // hover na offery
  (function offers(selector) {
    let hiddenParts = $(selector).find('.hidden-part')

    hiddenParts.each((index, item) => {
      let self = $(item)
      self.parent('.content').css({
        "bottom": `-${self.outerHeight()}px`
      })
    })
  })('#airticket-news')
})



/** WEBPACK FOOTER **
 ** c:/Users/martin.nikl/Desktop/SA GITLAB/frontend/sites/letenky.cz/src/js/subpages/dalsi-sluzby.js
 **/